module.exports = __webpack_public_path__ + "static/media/botones-04.762f14dc.png";